import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Box } from '@chakra-ui/react';

import ConfirmActionWarningModal from '../../../../../components/ConfirmActionWarningModal';
import StackedButtonGroup from '../../../../../components/Modal/ModalButtonGroups/StackedButtonGroup';
import { hideModal, selectModalButtons } from '../../../../../redux/modules/modal';
import { globalRequirementTemplateBuilder } from '../../../../../redux/reducer';

const DeleteTemplateFolderModal = ({ folderId }) => {
  const { isDisabled } = useSelector(selectModalButtons).primaryButtonOptions;
  const { currentFolder, data } = useSelector(globalRequirementTemplateBuilder.selectRequirementTemplateFolders);

  const dispatch = useDispatch();
  const history = useHistory();
  const { location } = history;

  const updatePath = updatedPath => {
    const newPathname = location.pathname
      .replace(`requirement-templates/${folderId}`, updatedPath);
    history.push(newPathname);
  };

  const handleFolderDelete = async () => {
    const templateFolderId = Number(folderId);
    const firstFolder = templateFolderId === data[0].id;
    const onlyFolder = firstFolder && data.length === 1;
    const isCurrent = templateFolderId === currentFolder
      || location.pathname.includes(`requirement-templates/${folderId}`);
    await dispatch(globalRequirementTemplateBuilder.deleteRequirementTemplateFolder(templateFolderId));

    if (onlyFolder) {
      updatePath('requirement-templates/archived');

      dispatch(globalRequirementTemplateBuilder.setCurrentRequirementTemplateFolder(''));
      dispatch(globalRequirementTemplateBuilder.listArchivedRequirementTemplates());
    } else if (!onlyFolder && firstFolder) {
      const firstId = data[1].id;

      updatePath(`requirement-templates/${firstId}`);
      dispatch(globalRequirementTemplateBuilder.listFolderRequirementTemplates(firstId));
    } else if (!onlyFolder && isCurrent) {
      updatePath('requirement-templates');

      const firstId = data.find(folder => folder.id !== templateFolderId);
      dispatch(globalRequirementTemplateBuilder.listFolderRequirementTemplates(firstId));
    }

    dispatch(globalRequirementTemplateBuilder.listRequirementTemplateFolders());
    dispatch(hideModal());
  };

  const description = 'The folder and any templates within the folder will be gone forever.';

  return (
    <>
      <ConfirmActionWarningModal description={description} />
      <Box mt={6}>
        <StackedButtonGroup
          isDisabled={isDisabled}
          label="Delete"
          onClick={handleFolderDelete}
        />
      </Box>
    </>
  );
};

export default DeleteTemplateFolderModal;
